unit GA.Web.Utils;

interface

type

TGAWebUtils = class
  class function RegulatorNumberValid(const ARegulator, ANumber: string): Boolean;
  class function EarliestClaimableDate(const ADate: TDate): TDate;
  class function EarliestClaimableDateStr(const ADate: TDate): string;
  class function EndofTaxYear(const ADate: TDate): TDate;
  class function StartOfTaxYear(const ADate: TDate): TDate;
  class function ClaimScopedStatusODataFilter(const AClaimStatus: string): string;
end;

TCountryUtils = class
  const UNKNOWN = 'Unspecified';
  const UNKNOWN_ALPHA2 = 'ZZ';
  class function GetCountryCodeFromCountryHelper(const aCountry: string): string;
  class function GetCountryFromCountryCodeHelper(const aCountryCode: string): string;
end;

implementation

uses System.SysUtils,
WebLib.RegularExpressions, System.DateUtils, WebLib.Country;

{ TGAWebUtils }

class function TGAWebUtils.RegulatorNumberValid(const ARegulator, ANumber: string): Boolean;
var lNumber: String;
begin
  lNumber := ANumber.Trim;
  Result := lNumber <> '';

  if not Result then
     Exit;

  { TODO : Check that the CharityId is a valid format TRegEx. }
end;


class function TGAWebUtils.EarliestClaimableDate(const ADate: TDate): TDate;
var
  lTaxYearEnd: TDate;
begin
  lTaxYearEnd := EndofTaxYear(ADate);
  Result := StartOfTaxYear(IncYear(lTaxYearEnd, -4));
end;

class function TGAWebUtils.EarliestClaimableDateStr(const ADate: TDate): string;
var
  lEarliestDate: TDate;
begin
  lEarliestDate := EarliestClaimableDate(ADate);
  result := FormatDateTime('DD/MM/YYYY', lEarliestDate);
end;

class function TGAWebUtils.EndofTaxYear(const ADate: TDate): TDate;
var
  lYear, lMonth, lDay: Word;
begin
  DecodeDate(ADate, lYear, lMonth, lDay);

  if (lMonth = 4) then
  begin
    if lDay > 5 then
      lYear := lYear + 1
  end
  else if lMonth > 4 then
  begin
    lYear := lYear + 1;
  end;

  Result := EncodeDate(lYear, 4, 5);
end;

class function TGAWebUtils.StartOfTaxYear(const ADate: TDate): TDate;
var
  lYear, lMonth, lDay: Word;
begin
  DecodeDate(ADate, lYear, lMonth, lDay);

  if (lMonth = 4) then
  begin
    if lDay < 6 then
      lYear := lYear - 1
  end
  else if lMonth < 4 then
  begin
    lYear := lYear - 1;
  end;

  Result := EncodeDate(lYear, 4, 6);
end;

class function TGAWebUtils.ClaimScopedStatusODataFilter(const AClaimStatus: string): string;
const
  InProcessStatuses =
    '(ClaimStatus eq ''Scheduled'' or ClaimStatus eq ''Submitting'' or ClaimStatus eq ''Confirmed''' +
    ' or ClaimStatus eq ''Claimed'' or ClaimStatus eq ''Received'')';
  SubmittedStatuses =
    '(ClaimStatus eq ''Submitting'' or ClaimStatus eq ''Confirmed''' +
    ' or ClaimStatus eq ''Claimed'' or ClaimStatus eq ''Received'')';
begin
  { Prepared claims keep Scheduled. Submitted claims drop leftover Scheduled. }
  if Trim(AClaimStatus) = '' then
    Result := InProcessStatuses
  else if SameText(AClaimStatus, 'Submitting') or SameText(AClaimStatus, 'Acknowledged') or
    SameText(AClaimStatus, 'Confirmed') or SameText(AClaimStatus, 'PaymentReceived') or
    SameText(AClaimStatus, 'Clearing') or SameText(AClaimStatus, 'ClaimCleared') or
    SameText(AClaimStatus, 'ClaimRejected') then
    Result := SubmittedStatuses
  else
    Result := 'ClaimStatus eq ''Scheduled''';
end;

class function TCountryUtils.GetCountryCodeFromCountryHelper(const aCountry: string): string;
begin
  if aCountry = UNKNOWN then
    Result := UNKNOWN_ALPHA2
  else
    Result := GetCountryCode(aCountry);
end;

class function TCountryUtils.GetCountryFromCountryCodeHelper(const aCountryCode: string): string;
begin
  if aCountryCode = UNKNOWN_ALPHA2 then
    Result := UNKNOWN
  else
    Result := GetCountryByCode(aCountryCode);
end;

end.
